import React from 'react';
import { Paper, Grid, Typography } from '@mui/material';
import globals from '../../globals.js';

const WhyChooseUs = () => {
    return (
        <>
            {/*  Защо да избереш eAcademiaBg? */}
            <Grid container sx={{ mt: 10 }} justifySelf={'center'}>
                <Paper square elevation={3} sx={{ px: 3, bgcolor: globals.colors.darkBlue, width: '100%' }}>
                    <Grid container sx={{ mt: 3 }} justifyItems={'center'} justifyContent={'center'}>
                        <Grid item justifySelf={'center'} size={{ xs: 10, sm: 5 }} textAlign={'center'}>
                            <Typography variant='h2' sx={{ color: globals.colors.backgroundColor, fontWeight: 'bold', fontSize: 35, textShadow: '3px 3px 5px rgba(0, 0, 0, 0.5)', }}>Защо да избереш eAcademiaBg?</Typography>
                        </Grid>
                    </Grid>

                    <Grid container sx={{ mt: 5 }} justifyContent={'space-around'} >
                        <Grid item sx={{ width: { xs: 1, sm: 0.3 } }} textAlign={'left'}>
                            <Grid container>
                                <img src='home_page_icon1.webp' loading="lazy" decoding="async" 
                                alt='Икона на интерактивна презентация с хора'
                                title='Интерактивно и интересно обучение'
                                style={{ height: 100, width: 100 }}></img>
                                <Typography sx={{ fontSize: 20, my: 4, mx: 2, color: globals.colors.backgroundColor, fontWeight: 'bold' }}>Интерактивно <br /> и интересно</Typography>
                            </Grid >
                            <Typography sx={{ color: globals.colors.backgroundColor }}>Нашата методика на преподаване има за цел
                                да предизвика учениците чрез въвеждане
                                на нови концепции и умения.</Typography>
                        </Grid>
                        <Grid item sx={{ width: { xs: 1, sm: 0.3 } }} textAlign={'left'}>
                            <Grid container>
                                <img 
                                alt=' Икона на учител пред клас'
                                title='Опитни преподаватели с дългогодишен опит'
                                src='home_page_icon2.webp' loading="lazy" decoding="async" style={{ height: 80, width: 100, marginTop: 15 }}></img>
                                <Typography sx={{ fontSize: 20, my: 4, mx: 2, color: globals.colors.backgroundColor, fontWeight: 'bold' }}>Опитни <br /> преподаватели</Typography>
                            </Grid >
                            <Typography sx={{ color: globals.colors.backgroundColor }}>Свързваме курсистите с компетентни преподаватели и лектори от цяла ​​България,
                                които са винаги на разположение да помагат.</Typography>
                        </Grid>
                        <Grid item sx={{ width: { xs: 1, sm: 0.3 } }} textAlign={'left'}>
                            <Grid container>
                                <img 
                                alt='Икона на смартфон и книга'
                                title='Учи онлайн, когато и където пожелаеш'
                                src='home_page_icon3.webp' loading="lazy" decoding="async" style={{ height: 80, width: 80, marginTop: 15 }}></img>
                                <Typography sx={{ fontSize: 20, my: 4, mx: 2, color: globals.colors.backgroundColor, fontWeight: 'bold' }}>Учиш навсякъде <br /> и по всяко време</Typography>
                            </Grid>
                            <Typography sx={{ color: globals.colors.backgroundColor }}>Онлайн уроците се вписват лесно в графика ти
                                – без пътуване и без притеснение.</Typography>
                        </Grid>
                    </Grid>


                    <Grid container sx={{ my: 5 }} justifyContent={'space-around'} >
                        <Grid item sx={{ width: { xs: 1, sm: 0.3 } }} textAlign={'left'}>
                            <Grid container>
                                <img 
                                alt='Икона на ръка, подаваща помощ'
                                title='Подкрепа и насоки за всеки ученик'
                                src='home_page_icon4.webp' loading="lazy" decoding="async" style={{ height: 80, width: 80, marginTop: 15 }}></img>
                                <Typography sx={{ fontSize: 20, my: 4, mx: 2, color: globals.colors.backgroundColor, fontWeight: 'bold' }}>Подкрепа <br /> и вдъхновение</Typography>
                            </Grid >
                            <Typography sx={{ color: globals.colors.backgroundColor }}>Градим увереност и интерес към ученето чрез положителна връзка между учител и ученик.</Typography>
                        </Grid>
                        <Grid item sx={{ width: { xs: 1, sm: 0.3 } }} textAlign={'left'}>
                            <Grid container>
                                <img 
                                alt='Икона на сърце и ученик'
                                title='Индивидуално внимание към всеки'
                                src='home_page_icon5.webp' loading="lazy" decoding="async" style={{ height: 90, width: 100, marginTop: 15 }}></img>
                                <Typography sx={{ fontSize: 20, my: 4, mx: 2, color: globals.colors.backgroundColor, fontWeight: 'bold' }}>Индивидуално <br /> внимание</Typography>
                            </Grid >
                            <Typography sx={{ color: globals.colors.backgroundColor }}>Чрез персонализираното внимание гарантираме, че всеки ученик е чут и разбран.</Typography>
                        </Grid>
                        <Grid item sx={{ width: { xs: 1, sm: 0.3 } }} textAlign={'left'}>
                            <Grid container>
                                <img 
                                alt='Икона на часовник'
                                title='Учи в собствения си ритъм'
                                src='home_page_icon6.webp' loading="lazy" decoding="async" style={{ height: 70, width: 70, marginTop: 20 }}></img>
                                <Typography sx={{ fontSize: 20, my: 4, mx: 2, color: globals.colors.backgroundColor, fontWeight: 'bold' }}>Пестиш време <br /> и пари</Typography>
                            </Grid>
                            <Typography sx={{ color: globals.colors.backgroundColor }}>Без излишно пътуване и разходи –
                                ефективно и удобно обучение от вкъщи.</Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </>
    );
}
export default WhyChooseUs;